export default __webpack_public_path__ + "static/media/panel7.cc6aefba.jpg";